import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const GoBackButton = ({ label = "Go Back" }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleGoBack = () => {
    // If user came from another page, go back
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      // If no history, send to home/dashboard
      navigate("/");
    }
  };

  return (
    <div className="w-full flex items-center mb-3">
      <button
        onClick={handleGoBack}
        className="flex items-center gap-2 text-sm font-medium text-blue-600 hover:text-blue-800 active:scale-95"
      >
        ← {label}
      </button>

      {/* <span className="ml-auto text-xs text-gray-400">
        {location.pathname}
      </span> */}
    </div>
  );
};

export default GoBackButton;
